import { useCallback, useState } from 'react';

import { useRouter } from 'expo-router';

import { routes } from 'utils/routing';

export const useStoreLocatorDialogs = ({
  onDismissInSupportForm,
}: {
  onDismissInSupportForm?: () => void;
}) => {
  const [dismissPromptOpen, setDismissPromptOpen] = useState(false);
  const router = useRouter();

  const dismissStoreLocator = useCallback(() => {
    if (router.canDismiss()) {
      router.dismiss();
    } else {
      router.replace(routes.base);
    }
  }, [router]);

  const handleCloseDismissPrompt = () => {
    setDismissPromptOpen(false);
  };

  const onDismissCallback = () => {
    dismissStoreLocator();
    onDismissInSupportForm?.();
  };

  return {
    dismissPromptOpen,
    handleCloseDismissPrompt,
    onDismissCallback,
  };
};
